import type { DocumentVariable, ScheduleSampleRow } from '../types/documentTemplates.types';

const isStringList = (sample: unknown): sample is string[] =>
  Array.isArray(sample) && sample.every((item) => typeof item === 'string');

const isRowList = (sample: unknown): sample is ScheduleSampleRow[] =>
  Array.isArray(sample) &&
  sample.length > 0 &&
  sample.every(
    (row) => typeof row === 'object' && row !== null && typeof row.label === 'string' && typeof row.amount === 'string',
  );

export function variableSample({ sample, type }: Pick<DocumentVariable, 'sample' | 'type'>): string {
  if (typeof sample === 'string') return sample;
  if (typeof sample === 'number') return String(sample);
  if (isStringList(sample)) return sample.join(', ');
  if (isRowList(sample)) return 'Table';
  return type;
}
